/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';

// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Table, Row, Col } from 'reactstrap';

class Tables extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cantidad: 0,
			perfiles: [],
		};
	}

	getSessionData(params) {
		return window.sessionStorage.getItem(params);
	}
	getProfiles = () => {
		if (this.getSessionData('UToken').length > 0) {
			var xhr = new XMLHttpRequest();

			// get a callback when the server responds
			xhr.addEventListener('load', () => {
				if (xhr.responseText !== 'No tienes mas perfiles!') {
					var result = JSON.parse(xhr.responseText);
					this.setState({
						cantidad: result.cantidad,
						perfiles: result.perfiles,
					});
				} else {
					this.setState({
						perfiles: [
							{
								id: 0,
								username: 'No hay perfiles!',
								password: 'Compra!!',
								country: 'Busca lo tuyo',
								useragent: 'Ta arrollao',
							},
						],
					});
				}
			});
			// open the request with the verb and the url
			xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/profiles/vertodo?owner=${this.getSessionData('UToken')}`);
			xhr.setRequestHeader('Authorization', 'BEARER ' + this.getSessionData('VToken'));

			// send the request
			xhr.send();
		}
	};
	componentDidMount() {
		this.getProfiles();
	}
	render() {
		return (
			<div className='content'>
				<Row>
					<Col md='12'>
						<Card className='card-plain'>
							<CardHeader>
								<CardTitle tag='h4'>
									Perfiles: <strong>{this.state.cantidad}</strong>
								</CardTitle>
							</CardHeader>
							<CardBody>
								<Table className='tablesorter' responsive>
									<thead className='text-primary'>
										<tr>
											<th>Usuario</th>
											<th>Cotraseña</th>
											<th>Pais</th>
											<th className='text-center'>User Agent</th>
										</tr>
									</thead>
									<tbody>
										{this.state.perfiles.map((perfil) => (
											<tr key={perfil.id}>
												<td>{perfil.username}</td>
												<td>{perfil.password}</td>
												<td>{perfil.country}</td>
												<td className='text-center'>{perfil.useragent}</td>
											</tr>
										))}
									</tbody>
								</Table>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</div>
		);
	}
}

export default Tables;
